module.exports = __webpack_public_path__ + "img/57000.788dfbee.jpg";